import { h, createRef, Fragment } from "preact";
import { useLayoutEffect } from "preact/hooks";

import Button from "./Button.jsx";
import Overlay from "./Overlay.jsx";

import i18n from "../i18n";
import Icon from "./Icon.jsx";
import { useSelector } from "react-redux";
import { selectCompany } from "../store/companySlice.js";
import { renderHtml } from "../helpers.js";

// TODO: Unify with ShareProfileDialog and other dialogs
export default function AddCaseDialog({ onClose, onOpen }) {
  const dialogRef = createRef();
  const overlayRef = createRef();

  const company = useSelector(selectCompany);

  useLayoutEffect(() => {
    // TODO: Some of this stuff should belong to Overlay and some should go into a
    //       general Dialog component
    const overlay = overlayRef.current.base;
    overlay.classList.add("overlay--open");
    const wrapper = dialogRef.current;
    wrapper.classList.add("dialog--open");
    wrapper.addEventListener(
      "animationend",
      () => {
        onOpen && onOpen();
      },
      { once: true } // Does not work in IE, but who cares
    );

    return () => {
      overlay.classList.add("overlay--exit");
      wrapper.classList.add("dialog--exit");

      return new Promise(function (resolve) {
        wrapper.addEventListener("animationend", resolve);
      });
    };
  }, []);

  return (
    <Fragment>
      <Overlay onClose={onClose} ref={overlayRef}>
        <section class="dialog dialog--md card" ref={dialogRef}>
          <h1 class="dialog__title t-h6 t-h6--margin">
            {i18n.t("pages.relocation_cases.add_case_modal.title")}
            <Icon class="dialog__closer" onClick={onClose}>
              close
            </Icon>
          </h1>

          <p>
            {renderHtml(
              i18n.t("pages.relocation_cases.add_case_modal.description", {
                code: company.invitationCode,
              })
            )}
          </p>
          <p>
            {renderHtml(
              i18n.t("pages.relocation_cases.add_case_modal.description2")
            )}
          </p>
          <div class="dialog__buttonRow">
            <Button onClick={onClose}>{i18n.t("actions.ok")}</Button>
          </div>
        </section>
      </Overlay>
    </Fragment>
  );
}
